import { createContext, useContext, useState } from "react"

type DisplayMode = "chance" | "price"

interface DisplayModeContextType {
  displayMode: DisplayMode
  setDisplayMode: (mode: DisplayMode) => void
}

const DisplayModeContext = createContext<DisplayModeContextType | undefined>(undefined)

export function DisplayModeProvider({ children }: { children: React.ReactNode }) {
  const [displayMode, setDisplayMode] = useState<DisplayMode>("chance")

  return <DisplayModeContext.Provider value={{ displayMode, setDisplayMode }}>{children}</DisplayModeContext.Provider>
}

export function useDisplayMode() {
  const context = useContext(DisplayModeContext)
  if (context === undefined) {
    throw new Error("useDisplayMode must be used within a DisplayModeProvider")
  }
  return context
}
